"use client";

export { useAuth } from "@/lib/guard/useAuth";
export type { LoginPayload } from "@/lib/guard/useAuth";
